export default "__VITE_ASSET__D1STJjqm__"